<button
  class="ant-tabs-nav-more"
  #dropdownTrigger="uiDropdown"
  *ngIf="items.length"
  [uiDropdownMenu]="menu"
  [uiOverlayStyle]="{ minWidth: '46px' }"
  [uiMatchWidthElement]="null"
  (uiVisibleChange)="menuVisChange($event)"
  (mouseenter)="showItems()"
  ui-dropdown
  type="button"
  tabindex="-1"
  aria-hidden="true"
  uiOverlayClassName="ui-tabs-dropdown">
  <i ui-icon uiType="ellipsis"></i>
</button>
<ui-dropdown-menu #menu="uiDropdownMenu">
  <ul *ngIf="menuOpened" ui-menu>
    <li
      class="ant-tabs-dropdown-menu-item"
      *ngFor="let item of items"
      [class.ant-tabs-dropdown-menu-item-disabled]="item.disabled"
      [uiSelected]="item.active"
      [uiDisabled]="item.disabled"
      (click)="onSelect(item)"
      (contextmenu)="onContextmenu(item, $event)"
      ui-menu-item>
      <ng-container *nzStringTemplateOutlet="item.tab.label; context: { visible: false }"> {{ item.tab.label }} </ng-container>
    </li>
  </ul>
</ui-dropdown-menu>
<button *ngIf="addable" [addIcon]="addIcon" (click)="addClicked.emit()" ui-tab-add-button></button>
